import React from "react";
import ProjectCard from "./ProjectCard";

function Projects() {
  return (
    <section>
      <section id="projects" className="project-section">
        <div>
          <h2>02/ projects</h2>
        </div>
        <div className="project-cards-container">
          <ProjectCard
            title="Budget Tracker"
            description="A responsive budget calculator that tracks income, expenses, and remaining balance with a visual spending chart.
Built with: HTML, CSS, JavaScript, and Chart.js."
            imageSrc={require("../img/clearbudget.png")}
            link1="https://clearbudgetproject.netlify.app/"
            link2="https://github.com/jmcushnie/clearbudget.git"
          />
          <ProjectCard
            title="Screen Time Rewards"
            description="A chore and screen-time reward dashboard built with React. Parents can create child profiles, assign tasks with minute rewards, and track daily progress through an interactive interface."
            imageSrc={require("../img/screentimeapp.png")}
            link1="https://screentimereward.netlify.app/"
            link2="https://github.com/jmcushnie/screen-time-app.git"
          />
          <ProjectCard
            title="My Wrapped"
            description="This project showcases my use of the Spotify Web API to create an interactive app that offers insights into your music listening habits."
            imageSrc={require("../img/Screenshot 2023-08-23 at 10.43.10 PM.png")}
            link1="https://mywrapped.netlify.app/"
            link2="https://github.com/jmcushnie/wrapped.git"
          />
          <ProjectCard
            title="Weather App"
            description="In this project i used the OpenWeatherAPI along with HTML, CSS and JavaScript to create a nice personal dashboard with your time, location and weather."
            imageSrc={require("../img//Screenshot 2023-08-23 at 10.41.40 PM.png")}
            link1="https://weather-app-jesscushnie.netlify.app/"
            link2="https://github.com/jmcushnie/Weather-app.git"
          />
        </div>
      </section>
    </section>
  );
}

export default Projects;
